import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "objectiveCard", "budgetInput", "budgetCentsInput", "budgetError",
    "countryTags", "countrySelect", "countriesInput",
    "ageMinInput", "ageMaxInput"
  ]

  static values = {
    objective: String,
    budgetMin: { type: Number, default: 5000 },
    countries: { type: Array, default: [] }
  }

  connect() {
    console.log("[tiktok-campaign-creator] connect: objective =", this.objectiveValue || "(empty)")
    this.updateObjectiveCards()
  }

  objectiveChanged(event) {
    const objective = event.target.value
    console.log("[tiktok-campaign-creator] objectiveChanged:", objective)
    this.objectiveValue = objective
    this.updateObjectiveCards()
    this.dispatch("changed", { detail: { objective } })
  }

  updateObjectiveCards() {
    this.objectiveCardTargets.forEach(card => {
      const objective = card.dataset.objective
      const selected = this.objectiveValue === objective

      card.classList.remove("border-brand", "bg-blue-50", "border-gray-200")

      if (selected) {
        card.classList.add("border-brand", "bg-blue-50")
      } else {
        card.classList.add("border-gray-200")
      }
    })
  }

  budgetInputChanged() {
    if (!this.hasBudgetInputTarget || !this.hasBudgetCentsInputTarget) return

    const euros = parseFloat(this.budgetInputTarget.value) || 0
    const cents = Math.round(euros * 100)
    this.budgetCentsInputTarget.value = cents

    if (this.hasBudgetErrorTarget) {
      if (euros > 0 && euros < 50) {
        this.budgetErrorTarget.classList.remove("hidden")
      } else {
        this.budgetErrorTarget.classList.add("hidden")
      }
    }

    this.dispatch("changed")
  }

  addCountry(event) {
    const code = event.target.value
    if (!code) return
    console.log("[tiktok-campaign-creator] addCountry:", code)

    const countries = this.getCountries()
    if (countries.includes(code)) return

    countries.push(code)
    this.setCountries(countries)
    event.target.value = ""

    const tag = document.createElement("span")
    tag.className = "inline-flex items-center gap-2 px-3 py-1 bg-gray-100 dark:bg-gray-700 border border-gray-200 dark:border-gray-600 text-gray-900 dark:text-gray-100 rounded-full text-sm"
    tag.innerHTML = `${code} <button type="button" class="font-bold hover:text-red-600 cursor-pointer" data-action="click->tiktok-campaign-creator#removeCountry" data-country="${code}">×</button>`
    this.countryTagsTarget.appendChild(tag)

    this.dispatch("changed")
  }

  removeCountry(event) {
    const code = event.currentTarget.dataset.country
    console.log("[tiktok-campaign-creator] removeCountry:", code)

    const countries = this.getCountries().filter(c => c !== code)
    this.setCountries(countries)

    event.currentTarget.closest("span").remove()
    this.dispatch("changed")
  }

  postChanged(event) {
    this.dispatch("changed", { detail: { postId: event.target.value } })
  }

  getCountries() {
    try {
      return JSON.parse(this.countriesInputTarget.value || "[]")
    } catch {
      return []
    }
  }

  setCountries(countries) {
    this.countriesInputTarget.value = JSON.stringify(countries)
  }

  disconnect() {
    console.log("[tiktok-campaign-creator] disconnect")
  }
}
